// @flow

import {
  Account,
  Connection,
  PublicKey,
  SystemProgram,
  Transaction,
} from '@solana/web3.js';
import {
  AccountLayout,
  Token,
} from '@solana/spl-token';
import Wallet from '@project-serum/sol-wallet-adapter';
import {TokenSale} from '../client/token-sale';
import {sendAndConfirmTransaction} from '../client/util/send-and-confirm-transaction';
import {createAssociatedTokenAccount} from '../client/util/create-associated-account';
import {
  newAccountWithLamports,
  loadAccountWithLamports,
  loadAccount,
  loadWalletWithLamports,
  loadWallet,
} from '../client/util/new-account-with-lamports';
import {url} from '../url';
import {sleep} from '../client/util/sleep';
import {
  TOKEN_PROGRAM_ID,
  ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID,
  TOKEN_SALE_PROGRAM_ID,
  TOKEN_WHITELIST_PROGRAM_ID,
  mintUSDTPubkey,
  mintSOLRPubkey,
  userAccountUSDT,
  poolAccountUSDT,
  userAccountSOLR,
  saleAccountSOLR,
  tokenSaleStateAccount,
  tokenWhitelistMap,
} from '../client/pubkeys';

// Token sale
let tokenSale: TokenSale;
// ownerPool of the pool accounts
let ownerPool: Account;
// ownerUser of the user accounts
let ownerUser: Account;
// mintAuthority of the usdt mint
let mintAuthority: Account;
// Token mints & accounts
let mintUSDT: Token;
let mintSOLR: Token;
let userTokenAccountUSDT: PublicKey;
let userTokenAccountSOLR: PublicKey;
let poolTokenAccountUSDT: PublicKey;
let poolTokenAccountSOLR: PublicKey;
let saleTokenAccountSOLR: PublicKey;

// Initial amount in each sale token
let currentSaleTokenUSDT = 100000;
let currentSaleTokenSOLR = 100000000;

const DECIMAL_MULTIPLIER = 1000000;


// This pubkey needs to be obtained from solrazr-api
//this is the bucket address assocaiated and stored inside the DB for connected wallet address
//get the public key from DB and create a PublicKey object, right now, it is hardcoded.

// function assert(condition, message) {
//   if (!condition) {
//     console.log(Error().stack + ':token-sale-test.js');
//     throw message || 'Assertion failed';
//   }
// }

let connection;
async function getConnection(): Promise<Connection> {
  if (connection) return connection;

  connection = new Connection(url, 'recent');
  const version = await connection.getVersion();

  console.log('Connection to cluster established:', url, version);
  return connection;
}


// Works only with wallet, not account - USE THIS
export async function ExecuteTokenSaleWithUserWallet(selectedWallet, amount, bucketId): Promise<void> {
  const connection = await getConnection();
  const userWallet = selectedWallet;
  const tokenWhitelistAccount = new PublicKey(bucketId); // generated from token whitelist program

  let localTokenSale = await TokenSale.createTokenSale(
    connection,
    userWallet, // payer
    mintUSDTPubkey,
    mintSOLRPubkey,
    tokenWhitelistMap,
    TOKEN_SALE_PROGRAM_ID,
    TOKEN_WHITELIST_PROGRAM_ID,
    TOKEN_PROGRAM_ID,
    ASSOCIATED_TOKEN_ACCOUNT_PROGRAM_ID,
  );

  console.log('Execute Sale - Start');
  await localTokenSale.executeTokenSaleWithUserWallet(
    userWallet,
    saleAccountSOLR,
    poolAccountUSDT,
    tokenSaleStateAccount,
    tokenWhitelistAccount,
    amount*DECIMAL_MULTIPLIER,
  );
  console.log('Execute Sale - End');
}


// if user solr account is not created
export async function createAssociatedTokenAccountForSolr(selectedWallet): Promise<void> {
  const connection = await getConnection();
  const userWallet = selectedWallet;

  console.log('Create Associated Token Account - Start');
  const [userDestination, txSig] = await createAssociatedTokenAccount(
    connection,
    userWallet,
    mintSOLRPubkey,
  );
  await connection.confirmTransaction(txSig, 'singleGossip');
  console.log('Create Associated Token Account - End');
}
